// Elearning Settings constants

// Earning Settings
export const GET_ELEARNING_SETTINGS_LOADING = "GET_ELEARNING_SETTINGS_LOADING";
export const GET_ELEARNING_SETTINGS_DATA = "GET_ELEARNING_SETTINGS_DATA";

export const UPDATE_ELEARNING_SETTINGS_LOADING =
  "UPDATE_ELEARNING_SETTINGS_LOADING";
export const UPDATE_ELEARNING_SETTINGS_DATA = "UPDATE_ELEARNING_SETTINGS_DATA";
